<template>
  <div class="popup-container popup-dialog popup-dialog-centered popup-dialog-scrollable justify-content-center">
    <div v-if="isLoaded" class="popup-package popup-coupon-manager-box">
      <div class="popup-content">
        <div class="popup-header popup-coupon-header">
          <h4 class="popup-coupon-title">
            {{ $t('Bao.payment_promo_code_manage') }}
          </h4>
          <a class="popup-close" @click.prevent="hideCoupon">
            <i class="fa-solid fa-xmark" aria-hidden="true" />
          </a>
        </div>

        <div class="popup-body popup-coupon-body">
          <div v-if="coupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_available') }}
              <span class="coupon-count">{{ coupons.length }}</span>
            </div>

            <div v-for="coupon in coupons" :key="coupon.id" class="coupon-card">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="coupon.module_name === 'FirstDeposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ coupon.code }}</span></p>
                <p class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ coupon.end_at | dateFormat }}</p>
              </a>
              <button class="coupon-btn coupon-btn-use" @click="$emit('applyCoupon', coupon.code)">
                {{ $t('Bao.payment_promo_code_apply') }}
              </button>
            </div>
          </div>

          <div v-if="registeredCoupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_registered_2') }}
              <span class="coupon-count">{{ registeredCoupons.length }}</span>
            </div>

            <div v-for="(registered, index) in registeredCoupons" :key="index" class="coupon-card coupon-card-used">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="registered.type === 'first_deposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ registered.code }}</span></p>
                <p class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ registered.updated_at | dateFormat }}</p>
              </a>
              <button class="coupon-btn coupon-btn-done">
                {{ $t('Bao.payment_promo_code_registered_1') }}
              </button>
            </div>
          </div>

          <div v-if="expiredCoupons.length > 0" class="coupon-section">
            <div class="coupon-section-title">
              {{ $t('Bao.payment_promo_code_ended_2') }}
              <span class="coupon-count">{{ expiredCoupons.length }}</span>
            </div>

            <div v-for="(expired, index) in expiredCoupons" :key="index" class="coupon-card coupon-card-done">
              <a class="coupon-card-link" href="javascript:;">
                <!--eslint-disable-next-line -->
                <span v-if="expired.type === 'first_deposit'" class="coupon-badge coupon-badge-name" @click="goEventPage" v-html="firstDepositText" />
                <p class="coupon-card-code">{{ $t('Bao.payment_promo_code_2') }}：<span>{{ expired.code }}</span></p>
                <p class="coupon-card-expire">{{ $t('Bao.payment_promo_code_expiry') }}：{{ expired.updated_at | dateFormat }}</p>
              </a>
              <button class="coupon-btn coupon-btn-done">
                {{ $t('Bao.payment_promo_code_ended_1') }}
              </button>
            </div>
          </div>
        </div>

        <div class="popup-coupon-footer">
          {{ $t('Bao.payment_promo_code_notice') }}
        </div>
      </div>
    </div>
    <i v-if="!isLoaded" class="fa fa-spinner fa-pulse fa-fw" />
  </div>
</template>
<script>
import { page } from '@/api/common'
import { getTaskList, getTaskCode } from '@/api/event'
import { showNotice } from '@/utils/tool'

export default {
  name: 'DepositCouponModal',
  data() {
    return {
      isLoaded: false,
      coupons: [],
      registeredCoupons: [],
      expiredCoupons: [],
      firstDepositText: '',
      firstDepositUrl: ''
    }
  },
  created() {
    const p1 = page({ type: 'first_deposit' }).then(response => {
      const data = response.data.data
      if (data && data.setting) {
        this.firstDepositText = data.content
        this.firstDepositUrl = data.setting.url
      }
    })

    const p2 = getTaskList().then(response => {
      const list = response.data.data.list

      this.registeredCoupons = list.filter(c => c.activate_no === '0')
      this.expiredCoupons = list.filter(c => c.activate_no !== '0')

      return getTaskCode().then(res => {
        const taskCodeList = res.data.data.list

        if (!list.length) {
          this.coupons = taskCodeList
          return
        }

        const taskCodes = taskCodeList.map(t => t.code)
        this.coupons = this.registeredCoupons.filter(c => !taskCodes.includes(c.code))
      })
    })

    Promise.all([p1, p2]).then(() => {
      const hasNoFirstDepositData = !this.firstDepositText && !this.firstDepositUrl
      const hasNoCoupons = this.coupons.length === 0 && this.registeredCoupons.length === 0 && this.expiredCoupons.length === 0

      if (hasNoFirstDepositData && hasNoCoupons) {
        showNotice(this.$t('Bao.payment_promo_code_no_data'))
        this.hideCoupon()
        return
      }

      this.isLoaded = true
    })
  },
  methods: {
    hideCoupon() {
      this.$emit('closeCoupon')
    },
    goEventPage() {
      this.$router.push(this.firstDepositUrl)
    }
  }
}
</script>
